import { encode } from "js-base64"
import { Instance, SnapshotOut, types, getRoot } from "mobx-state-tree"
import { UserGender, UserLastSeenData } from "~proto"
import { numEnumeration } from "~types/enum"
import { staticUrl } from "~utils"
import { RootStoreModel } from "~models/root-store"
/**
 * 用户模型，存储用户相关的数据
 */
export const UserModel = types
  .model("User")
  .props({
    id: types.identifierNumber,
    username: types.string,
    name: types.string,
    phone: types.maybeNull(types.string),
    email: types.maybeNull(types.string),
    avatar: types.maybeNull(types.string),
    last_seen: types.maybeNull(types.number),
    online: types.maybeNull(types.boolean),
    is_id_verify: types.maybe(types.boolean),
    is_phone_verify: types.maybe(types.boolean),
    is_pay_password: types.maybeNull(types.boolean),
    gender: types.maybeNull(types.optional(numEnumeration<UserGender>("UserGender", Object.values(UserGender)),UserGender.MALE)),
  })
  .views((self) => ({
    get displayName() {
      return self.name || self.username || ""
    },
    get img() {
      return self.avatar ? staticUrl(self.avatar) : ""
    },
    get receiveQrcode() {
      const { configStore } = getRoot<Instance<typeof RootStoreModel>>(self)
      const path = "receive"
      const data = {
        path,
        id: self.id,
        username: self.username,
        name: self.name,
        avatar: self.avatar,
        gender: self.gender,
      }
      const t = JSON.stringify(data)
      const b = encode(t)
      return `${configStore.redirectURL}?appKey=${configStore.appKey}&path=${path}&data=${b}`
    },
    get qrcode() {
      const { configStore } = getRoot<Instance<typeof RootStoreModel>>(self)
      const path = "contact"
      const data = {
        path,
        id: self.id,
        username: self.username,
        name: self.name,
        avatar: self.avatar,
        gender: self.gender,
      }
      const b = encode(JSON.stringify(data))
      const dataQs = `path=${encodeURIComponent(path)}&data=${encodeURIComponent(b)}`
      const redirect = (configStore.redirectURL || "").trim()
      const appKey = (configStore as { appKey?: string }).appKey
      if (redirect) {
        const sep = redirect.includes("?") ? "&" : "?"
        const keyQs =
          appKey != null && String(appKey) !== "" ? `appKey=${encodeURIComponent(String(appKey))}&` : ""
        return `${redirect}${sep}${keyQs}${dataQs}`
      }
      // 扫码页只解析 path / data，不依赖 H5 域名与 appKey
      return `https://qrcode.internal/?${dataQs}`
    },
    get atUsername() {
      return `账号:${self.username}`
    },
    get atNickame() {
      return `昵称:${self.name}`
    },
  }))
  .actions((self) => ({
    onLastSeen({ data }: { data: UserLastSeenData }) {
      self.online = data.online
      self.last_seen = data.last_seen
    },
    update(values) {
      for (const key in values) {
        self[key] = values[key]
      }
      return self
    },
  }))

export type UserType = Instance<typeof UserModel>
export interface User extends UserType {
  name: any
  id(id: any): unknown
  displayName: any;
}
type UserSnapshotType = SnapshotOut<typeof UserModel>
export interface UserSnapshot extends UserSnapshotType {}
export const createUserDefaultModel = () => types.optional(UserModel, {})
